export const tpfrontup =
  "Szukasz wakacji <span>last minute</span>?";
export const tpfrontdown = "Sprawdź na Travelplanet.pl";
export const tplink = "https://www.travelplanet.pl/wakacje/super-last-minute/";
